import MentoringCard from './MentoringCard.vue';

export default MentoringCard;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/card/index.ts